<template>
  <div class="flex jcsa aic header-wrap white-bg">
    <div class="flex jcc aic">
      <img style="width: 11.5%" src="https://qishimai-1257428522.file.myqcloud.com/website/new/logo.png" />
      <div class="tabs-btn fs16 cp" v-for="(item, index) in commonData.headbar" :key="index" :class="index === tab ? 'main-color' : '' " @click="tabOnclick(item.key)">{{item.label}}</div>
    </div>
    <div class="flex aic main-bg phone-btn cp" @click="copyText('4008-270-170')">
      <img style="height:60%;margin-right:8px" src="https://qishimai-1257428522.file.myqcloud.com/website/new/phone_icon.png" />
      <div class="white-color fs16">4008-270-170</div>
    </div>
    <div v-if="showToast" class="toast">
      <div>{{toastContent}}</div>
    </div>
  </div>
</template>

<script>
import commonData from '@/utils/staticData/commonData';
export default {
  name: 'Header',
  props: {
    tab: { type: Number, default: 0 },
  },
  data () {
    return {
      commonData,
      showToast: false,
      toastContent: '',
    }
  },
  methods: {
    tabOnclick(key) {
      if (window.location.hash === `#/${key === 'home' ? '' : key}`) {
        return
      }
      switch (key) {
        case 'home':
          this.$router.push({ path: '/' });
          setTimeout(() => {
            document.documentElement.scrollTop = 0;
          }, 10)
          break;
        case 'customize':
          this.$router.push({ path: '/customize' });
          setTimeout(() => {
            document.documentElement.scrollTop = 0;
          }, 10)
          break;
        default:
          this.$router.push({ path: '/' });
          setTimeout(() => {
            document.getElementById(key).scrollIntoView({block: "center", behavior: "smooth"});
          }, 10)
      }
    },
    async copyText(text){
      let target = document.createElement('input') //创建input节点
      target.value = text // 给input的value赋值
      document.body.appendChild(target) // 向页面插入input节点
      target.select() // 选中input
      try {
        await document.execCommand('Copy') // 执行浏览器复制命令
        this.toast('复制成功')
      } catch(e) {
        this.toast('复制失败')
      }
    },
    toast(content) {
      this.toastContent = content;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 2000)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header-wrap {
  position: sticky;
  top: 0;
  height: 4.7vw;
  max-height: 90px;
  min-height: 56.3px;
  box-shadow: 0px 2px 8px rgba(128, 128, 128, 0.16);
  z-index: 5;
}
.tabs-btn {
  padding: 15px 0 15px 30px;
  font-weight: 500;
}
.phone-btn {
  height: 2.35vw;
  max-height: 45px;
  min-height: 28.2px;
  padding: 0 0.6vw;
  border-radius: 5px;
  /* line-height: 26px; */
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue